<template>
  <div class="host">
    <div class="w1200">
      <div class="logo_title">
        <img class="header_logo" src="../assets/6097@2x.png" alt />
        <p>v1.50</p>
      </div>

      <div class="back_choice">
        <div class="left" @click="backwebsite">
          <img src="../assets/back_home.png" alt />
          <p>返回官网首页</p>
        </div>
        <div class="right" @click="cancellation">
          <img src="../assets/cancellation.png" alt />
          <p>退出登录</p>
        </div>
      </div>
    </div>
    <!-- <div class="header">
			<div class="header_top w-1200">
				<img class="logo" src="../assets/2.png" />
				<form class="search-inp" action="/search">
					<div class="search-inp_prefix">
						<select name="type">
							<option value="1">全站</option>
							<option value="2">XXX</option>
							<option value="3">DDD</option>
						</select>
					</div>
					<input name="keyword" placeholder="输入要搜索的内容" /><button type="submit">
						<img class="h-1d4em" src="../assets/5.png" />
					</button>
				</form>
			</div>
			<div class="header_main">
				<div class="nav">
					<div class="nav_item"><a href="/">首页</a></div>
					<div class="nav_item __active"><a href="/">协会概况</a></div>
					<div class="nav_item">
						<a href="/">新闻公告</a>
						<div class="nav_sub">
							<a class="nav_sub-item" href="/">新闻公告告0</a><a class="nav_sub-item" href="/">新闻公告告1</a><a
								class="nav_sub-item" href="/">新闻公告告2</a><a class="nav_sub-item" href="/">新闻公告告3</a><a
								class="nav_sub-item" href="/">新闻公告告4</a>
						</div>
					</div>
					<div class="nav_item">
						<a href="/">政策法规
						</a>
						<div class="nav_sub">
							<a class="nav_sub-item" href="/">政策法规策法规0</a><a class="nav_sub-item" href="/">政策法规策法规1</a><a
								class="nav_sub-item" href="/">政策法规策法规2</a><a class="nav_sub-item"
								href="/">政策法规策法规3</a><a class="nav_sub-item" href="/">政策法规策法规4</a>
						</div>
					</div>
					<div class="nav_item"><a href="/">培训信息</a></div>
					<div class="nav_item"><a href="/">会员单位</a></div>
					<div class="nav_item"><a href="/">文件下载</a></div>
					<div class="nav_item"><a href="/">专家库</a></div>
					<div class="nav_item"><a href="/">创先争优</a></div>
					<div class="nav_item_h nav_item __red"><a class="nav_item_a" href="javascript:void(0)">会员中心</a>
						<div v-if="token" class="nav_sub_h">
							<a class="nav_sub-item_h_s nav_sub-item_h_s_t_r" href="javascript:void(0)">贵州华盈建筑集...
								<img class="" src="../assets/18.png" />
							</a>
							<a v-for="(item,index) in navItem" :key="index" class="nav_sub-item_h"
								:href="'#/member/'+item.name">{{item.val}}</a>
							<a class="nav_sub-item_h_s nav_sub-item_h_s_red nav_sub-item_h_s_b_r" href="/login">
								<img class="guanbi" src="../assets/guanbi.png" />
								退出登录
							</a>
						</div>
						<div v-else class="nav_sub_h">
							<div class="nav_sub-item_h_s ">
								<a class="nav_sub-item_h_s_m" href="/login">
									会员登录
								</a>
								<a class="nav_sub-item_h_s_m" style="margin-top:7px;border: 1px solid #E51725;"
									href="/login">
									非会员登录
								</a>
								<div class="nav_sub-item_h_s_t">
									<span>没有账号？</span>
									<a href="/#/register">点击注册</a>
								</div>
							</div>

						</div>
					</div>
				</div>
				<div class="notice-bar">
					<div class="notice-bar_prefix">
						<img class="h-1d2em" src="../assets/6.png" /> 协会通知
					</div>
					<div class="notice-bar_content">
						<div class="notice-bar_item J_notice">
							会议中心举办了国家标准《绿色建筑评价标准》（GBT50378-2019）宣贯培训会议。会议由邹雨副秘书长主持，参加此次会议的
						</div>
						<div class="notice-bar_item J_notice">
							知通的》知通的动活训培列系术技工施键关质地杂复殊特期一第度年1202办举于关《会协理管业企工施国中发转于关
						</div>
						<div class="notice-bar_item J_notice">
							关于转发中国施工企业管理协会《关于举办2021年度第一期特殊复杂地质关键施工技术系列培训活动的通知》的通知
						</div>
					</div>
					<div class="notice-bar_suffix">
						<img class="notice-bar_btn" id="J_notice_prev" src="../assets/7.png" /><span
							class="notice-bar_no" id="J_notice_pager"></span><img class="notice-bar_btn __reverse"
							id="J_notice_next" src="../assets/7.png" />
					</div>
				</div>
			</div>
    </div>-->
  </div>
</template>
<script>
import { scrollNotice } from "../utils/scroll-notice";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      token: "",
      navItem: [
        {
          val: "基础信息",
          name: "infor"
        },
        // {
        //   val: "奖项管理",
        //   name: "award"
        // },
        // {
        //   val: "申请会员",
        //   name: "apply"
        // },
        {
          val: "会员升级",
          name: "upgrade"
        },
        {
          val: "申报项目",
          name: "declear"
        },
        {
          val: "缴费记录",
          name: "record"
        }
      ]
    };
  },
  mounted() {
    scrollNotice();
    this.token = "Bearer " + localStorage.getItem("TOKEN");
  },
  methods: {
    cancellation(){
      // 专家端（含工法专家端首页）的任意页面退出后均返回专家登录页。
      if(this.$route.path.indexOf('/expertmember') === 0 || this.$route.path.indexOf('/gfprize') === 0){
        this.$router.push('/expert')
      }else{
        this.$router.push('/')
      }
      localStorage.removeItem('TOKEN')
    },
    backwebsite(){
      window.location.href = '/'
    }
  }
};
</script>

<style lang="less" scoped>
body,
html {
  min-height: 100%;
}

input::-ms-clear,
input::-ms-reveal {
  display: none;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

@-ms-viewport {
  width: device-width;
}

article,
aside,
dialog,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  margin: 0;
  color: var(--m78-color-primary);
  font-size: var(--m78-fs);
  font-family: var(--m78-font-family);
  font-variant: tabular-nums;
  line-height: var(--m78-line-height);
  background-color: var(--m78-body-bg);
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum";
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: transparent;
}

[tabindex="-1"]:focus {
  outline: none !important;
}

hr {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: var(--m78-color-title);
  font-weight: 500;
}

p {
  margin-top: 0;
  margin-bottom: 1em;
}

abbr[data-original-title],
abbr[title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  border-bottom: 0;
  cursor: help;
}

address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}

input[type="number"],
input[type="password"],
input[type="text"],
textarea {
  -webkit-appearance: none;
}

dl,
ol,
ul {
  margin-top: 0;
  margin-bottom: 1em;
}

ol ol,
ol ul,
ul ol,
ul ul {
  margin-bottom: 0;
}

dt {
  font-weight: 500;
}

dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1em;
}

dfn {
  font-style: italic;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--m78-color);
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
  -webkit-transition: color 0.3s;
  -o-transition: color 0.3s;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
  outline-offset: -1px;
}

a:hover {
  color: var(--m78-color-5);
}

a:active {
  color: var(--m78-color-7);
}

a:active,
a:hover {
  text-decoration: none;
  outline: 0;
}

a:focus {
  outline: var(--m78-color) auto 1px;
}

a[disabled] {
  color: var(--m78-color-disable);
  cursor: not-allowed;
  pointer-events: none;
}

a.__noOutline {
  outline: none !important;
}

.outline:focus,
[tabindex]:focus {
  outline: var(--m78-color) auto 1px;
}

code,
kbd,
pre,
samp {
  font-size: 1em;
  font-family: var(--m78-code-family);
}

pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}

figure {
  margin: 0 0 1em;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg:not(:root) {
  overflow: hidden;
}

[role="button"],
a,
area,
button,
input:not([type="range"]),
label,
select,
summary,
textarea {
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: var(--m78-color-second);
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

button,
input,
optgroup,
select,
textarea {
  margin: 0;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[type="reset"],
[type="submit"],
button,
html [type="button"] {
  -webkit-appearance: button;
}

[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner,
button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="checkbox"],
input[type="radio"] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
}

input[type="date"],
input[type="datetime-local"],
input[type="month"],
input[type="time"] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5em;
  padding: 0;
  color: inherit;
  font-size: 1.5em;
  line-height: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

mark {
  padding: 0.2em;
  background-color: #fffb8f;
}

::-moz-selection {
  background: var(--m78-color);
  color: var(--m78-color-title);
}

::selection {
  background: var(--m78-color);
  color: var(--m78-color-title);
}

.hide {
  display: none !important;
}

.show {
  display: block !important;
}

.visible {
  visibility: visible !important;
}

.hidden {
  visibility: hidden !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-1 {
  opacity: 1 !important;
}

.float-right {
  float: right !important;
}

.float-left {
  float: left !important;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

.center-block {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.psr {
  position: relative !important;
}

.psa {
  position: absolute !important;
}

.move-t1 {
  position: relative;
  top: -1px !important;
}

.move-t2 {
  position: relative;
  top: -2px !important;
}

.move-t3 {
  position: relative;
  top: -3px !important;
}

.move-b1 {
  position: relative;
  bottom: -1px !important;
}

.move-b2 {
  position: relative;
  bottom: -2px !important;
}

.move-b3 {
  position: relative;
  bottom: -3px !important;
}

.color-red {
  color: #f5222d !important;
}

.color-orange {
  color: #fa8c16 !important;
}

.color-yellow {
  color: #fadb14 !important;
}

.color-green {
  color: #52c41a !important;
}

.color-cyan {
  color: #13c2c2 !important;
}

.color-blue {
  color: #1890ff !important;
}

.color-purple {
  color: #722ed1 !important;
}

.bg-red {
  background-color: #f5222d !important;
}

.bg-orange {
  background-color: #fa8c16 !important;
}

.bg-yellow {
  background-color: #fadb14 !important;
}

.bg-green {
  background-color: #52c41a !important;
}

.bg-cyan {
  background-color: #13c2c2 !important;
}

.bg-blue {
  background-color: #1890ff !important;
}

.bg-purple {
  background-color: #722ed1 !important;
}

.h-1em {
  height: 1em !important;
}

.h-0d8em {
  height: 0.8em !important;
}

.h-1d2em {
  height: 1.2em !important;
}

.h-1d4em {
  height: 1.4em !important;
}

.w-fifth {
  width: 20% !important;
}

.w-fourth {
  width: 25% !important;
}

.w-third {
  width: 33.3333% !important;
}

.w-half {
  width: 50% !important;
}

.w-full {
  width: 100% !important;
}

.w-1em {
  width: 1em !important;
}

.w-0d8em {
  width: 0.8em !important;
}

.w-1d2em {
  width: 1.2em !important;
}

.w-1d4em {
  width: 1.4em !important;
}

.ellipsis {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.fw {
  font-weight: var(--fw) !important;
}

.fw-md {
  font-weight: var(--m78-fw-md) !important;
}

.bold {
  font-weight: var(--m78-fw-bold) !important;
}

.lh-0 {
  line-height: 0 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-base {
  line-height: var(--m78-line-height) !important;
}

.lh-2 {
  line-height: 2 !important;
}

.tl {
  text-align: left !important;
}

.tc {
  text-align: center !important;
}

.tr {
  text-align: right !important;
}

.vm {
  vertical-align: middle !important;
}

.vt {
  vertical-align: top !important;
}

.color-title {
  color: var(--m78-color-title) !important;
}

.color-primary {
  color: var(--m78-color-primary) !important;
}

.color-second {
  color: var(--m78-color-second) !important;
}

.color-disabled {
  color: var(--m78-color-disable) !important;
}

.color-border {
  color: var(--m78-color-border) !important;
}

.color-divider {
  color: var(--m78-color-divider) !important;
}

.color-title-w {
  color: var(--m78-color-title-w) !important;
}

.color-primary-w {
  color: var(--m78-color-primary-w) !important;
}

.color-second-w {
  color: var(--m78-color-second-w) !important;
}

.color-disabled-w {
  color: var(--m78-color-disable-w) !important;
}

.color-border-w {
  color: var(--m78-color-border-w) !important;
}

.color-divider-w {
  color: var(--m78-color-divider-w) !important;
}

.color-bg {
  color: var(--m78-color-bg) !important;
}

.color {
  color: var(--m78-color-6) !important;
}

.color-l {
  color: var(--m78-color-4) !important;
}

.color-d {
  color: var(--m78-color-8) !important;
}

.color-sub {
  color: var(--m78-color-sub-6) !important;
}

.color-sub-l {
  color: var(--m78-color-sub-4) !important;
}

.color-sub-d {
  color: var(--m78-color-sub-8) !important;
}

.color-info {
  color: var(--m78-color-info) !important;
}

.bg-info {
  background-color: var(--m78-color-info) !important;
}

.color-success {
  color: var(--m78-color-success) !important;
}

.bg-success {
  background-color: var(--m78-color-success) !important;
}

.color-warn {
  color: var(--m78-color-warn) !important;
}

.bg-warn {
  background-color: var(--m78-color-warn) !important;
}

.color-error {
  color: var(--m78-color-error) !important;
}

.bg-error {
  background-color: var(--m78-color-error) !important;
}

.fs-sm {
  font-size: var(--m78-fs-sm) !important;
}

.fs {
  font-size: var(--m78-fs) !important;
}

.fs-md {
  font-size: var(--m78-fs-md) !important;
}

.fs-lg {
  font-size: var(--m78-fs-lg) !important;
}

.fs-12 {
  font-size: 12px;
}

.fs-14 {
  font-size: 14px;
}

.fs-16 {
  font-size: 16px;
}

.fs-18 {
  font-size: 18px;
}

.fs-20 {
  font-size: 20px;
}

.fs-22 {
  font-size: 22px;
}

.fs-24 {
  font-size: 24px;
}

.fs-28 {
  font-size: 28px;
}

.fs-32 {
  font-size: 32px;
}

.fs-36 {
  font-size: 36px;
}

.fs-40 {
  font-size: 40px;
}

.m-4 {
  margin: 4px !important;
}

.mt-4 {
  margin-top: 4px !important;
}

.mr-4 {
  margin-right: 4px !important;
}

.ml-4 {
  margin-left: 4px !important;
}

.mb-4,
.mtb-4 {
  margin-bottom: 4px !important;
}

.mtb-4 {
  margin-top: 4px !important;
}

.mlr-4 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.m-8 {
  margin: 8px !important;
}

.mt-8 {
  margin-top: 8px !important;
}

.mr-8 {
  margin-right: 8px !important;
}

.ml-8 {
  margin-left: 8px !important;
}

.mb-8,
.mtb-8 {
  margin-bottom: 8px !important;
}

.mtb-8 {
  margin-top: 8px !important;
}

.mlr-8 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.m-12 {
  margin: 12px !important;
}

.mt-12 {
  margin-top: 12px !important;
}

.mr-12 {
  margin-right: 12px !important;
}

.ml-12 {
  margin-left: 12px !important;
}

.mb-12,
.mtb-12 {
  margin-bottom: 12px !important;
}

.mtb-12 {
  margin-top: 12px !important;
}

.mlr-12 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}

.m-16 {
  margin: 16px !important;
}

.mt-16 {
  margin-top: 16px !important;
}

.mr-16 {
  margin-right: 16px !important;
}

.ml-16 {
  margin-left: 16px !important;
}

.mb-16,
.mtb-16 {
  margin-bottom: 16px !important;
}

.mtb-16 {
  margin-top: 16px !important;
}

.mlr-16 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.m-24 {
  margin: 24px !important;
}

.mt-24 {
  margin-top: 24px !important;
}

.mr-24 {
  margin-right: 24px !important;
}

.ml-24 {
  margin-left: 24px !important;
}

.mb-24,
.mtb-24 {
  margin-bottom: 24px !important;
}

.mtb-24 {
  margin-top: 24px !important;
}

.mlr-24 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}

.m-32 {
  margin: 32px !important;
}

.mt-32 {
  margin-top: 32px !important;
}

.mr-32 {
  margin-right: 32px !important;
}

.ml-32 {
  margin-left: 32px !important;
}

.mb-32,
.mtb-32 {
  margin-bottom: 32px !important;
}

.mtb-32 {
  margin-top: 32px !important;
}

.mlr-32 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}

.p-8 {
  padding: 8px !important;
}

.pt-8 {
  padding-top: 8px !important;
}

.pr-8 {
  padding-right: 8px !important;
}

.pl-8 {
  padding-left: 8px !important;
}

.pb-8,
.ptb-8 {
  padding-bottom: 8px !important;
}

.ptb-8 {
  padding-top: 8px !important;
}

.plr-8 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.p-12 {
  padding: 12px !important;
}

.pt-12 {
  padding-top: 12px !important;
}

.pr-12 {
  padding-right: 12px !important;
}

.pl-12 {
  padding-left: 12px !important;
}

.pb-12,
.ptb-12 {
  padding-bottom: 12px !important;
}

.ptb-12 {
  padding-top: 12px !important;
}

.plr-12 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.p-16 {
  padding: 16px !important;
  padding-top: 16px !important;
}

.pr-16 {
  padding-right: 16px !important;
}

.pl-16 {
  padding-left: 16px !important;
}

.pb-16 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.p-16 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.p-24 {
  padding: 24px !important;
  padding-top: 24px !important;
  padding-right: 24px !important;
  padding-left: 24px !important;
}

.pb-24,
.ptb-24 {
  padding-bottom: 24px !important;
}

.ptb-24 {
  padding-top: 24px !important;
}

.plr-24 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.p-32 {
  padding: 32px !important;
}

.pt-32 {
  padding-top: 32px !important;
}

.pr-32 {
  padding-right: 32px !important;
}

.pl-32 {
  padding-left: 32px !important;
}

.pb-32,
.ptb-32 {
  padding-bottom: 32px !important;
}

.ptb-32 {
  padding-top: 32px !important;
}

.plr-32 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.divide-8 {
  height: 8px;
}

.divide-16 {
  height: 16px;
}

.divide-24 {
  height: 24px;
}

.divide-32 {
  height: 32px;
}

.divide-40 {
  height: 40px;
}

.divide-48 {
  height: 48px;
}

.radius {
  border-radius: var(--m78-border-radius);
}

.shadow-0 {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.shadow-1 {
  -webkit-box-shadow: var(--m78-shadow-1);
  box-shadow: var(--m78-shadow-1);
}

.shadow-2 {
  -webkit-box-shadow: var(--m78-shadow-2);
  box-shadow: var(--m78-shadow-2);
}

.shadow-3 {
  -webkit-box-shadow: var(--m78-shadow-3);
  box-shadow: var(--m78-shadow-3);
}

.m78-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: var(--m78-color-disable);
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 4px;
}

.m78-dot.__red {
  border-color: var(--m78-color-error);
}

.m78-dot.__blue {
  border-color: var(--m78-color-info);
}

.m78-dot.__yellow {
  border-color: var(--m78-color-warn);
}

.m78-dot.__green {
  border-color: var(--m78-color-success);
}

.m78-triangle {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-left: 5px solid var(--m78-color-second);
  border-radius: 2px;
}

.m78-animated-spin {
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-animation: m78-spin 2s linear infinite;
  animation: m78-spin 2s linear infinite;
}

.m78-animated-steps {
  -webkit-animation: m78-spin 1s steps(8) infinite;
  animation: m78-spin 1s steps(8) infinite;
}

@-webkit-keyframes m78-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

@keyframes m78-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.m78-mask {
  background-color: var(--m78-mask);
}

.m78-mask,
.m78-mask-b {
  position: fixed;
  z-index: var(--m78-z-index);
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}

.m78-mask-b {
  background-color: rgba(0, 0, 0, 0.75);
}

.circle-img {
  border-radius: 50%;
  overflow: hidden;
}

.border,
.circle-img {
  border: 1px solid var(--m78-color-border);
}

.border-t {
  border-top: 1px solid var(--m78-color-border);
}

.border-r {
  border-right: 1px solid var(--m78-color-border);
}

.border-b {
  border-bottom: 1px solid var(--m78-color-border);
}

.border-l {
  border-left: 1px solid var(--m78-color-border);
}

.m78-hb-t:before {
  top: 0;
}

.m78-hb-b:after,
.m78-hb-t:before {
  position: absolute;
  content: "";
  height: 1px;
  left: 0;
  right: 0;
  background-color: var(--m78-color-border);
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.m78-hb-b:after {
  bottom: 0;
}

.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.expand {
  position: relative;
}

.expand:before {
  content: "";
  position: absolute;
  left: -30%;
  top: -30%;
  right: -30%;
  bottom: -30%;
}

.effect-shadow {
  cursor: pointer;
  -webkit-box-shadow: var(--m78-shadow-1);
  box-shadow: var(--m78-shadow-1);
  -webkit-transition: -webkit-box-shadow var(--m78-animate-base);
  transition: -webkit-box-shadow var(--m78-animate-base);
  -o-transition: box-shadow var(--m78-animate-base);
  transition: box-shadow var(--m78-animate-base);
  transition: box-shadow var(--m78-animate-base),
    -webkit-box-shadow var(--m78-animate-base);
}

.effect-shadow:hover {
  -webkit-box-shadow: var(--m78-shadow-2);
  box-shadow: var(--m78-shadow-2);
}

.effect-shadow:active {
  -webkit-transition: -webkit-box-shadow var(--m78-animate-base) 0.1s;
  transition: -webkit-box-shadow var(--m78-animate-base) 0.1s;
  -o-transition: box-shadow var(--m78-animate-base) 0.1s;
  transition: box-shadow var(--m78-animate-base) 0.1s;
  transition: box-shadow var(--m78-animate-base) 0.1s,
    -webkit-box-shadow var(--m78-animate-base) 0.1s;
  -webkit-box-shadow: var(--m78-shadow-1-focus);
  box-shadow: var(--m78-shadow-1-focus);
}

.effect-bg {
  cursor: pointer;
  -webkit-transition: background-color var(--m78-animate-base);
  -o-transition: background-color var(--m78-animate-base);
  transition: background-color var(--m78-animate-base);
}

.effect-bg:hover {
  background-color: var(--m78-color-divider);
}

.effect-bg:active {
  -webkit-transition: background-color var(--m78-animate-base) 0.1s;
  -o-transition: background-color var(--m78-animate-base) 0.1s;
  transition: background-color var(--m78-animate-base) 0.1s;
  background-color: var(--m78-color-border);
}

.effect-border {
  cursor: pointer;
  -webkit-transition: border var(--m78-animate-base);
  -o-transition: border var(--m78-animate-base);
  transition: border var(--m78-animate-base);
  border: 1px solid transparent;
}

.effect-border:hover {
  border: 1px solid var(--m78-color-border);
}

.effect-border:active {
  -webkit-transition: border var(--m78-animate-base) 0.1s;
  -o-transition: border var(--m78-animate-base) 0.1s;
  transition: border var(--m78-animate-base) 0.1s;
  border: 1px solid var(--m78-color-disable);
}

.effect-opacity {
  cursor: pointer;
  -webkit-transition: opacity var(--m78-animate-base);
  -o-transition: opacity var(--m78-animate-base);
  transition: opacity var(--m78-animate-base);
}

.effect-opacity:hover {
  opacity: 0.8;
}

.effect-opacity:active {
  -webkit-transition: opacity var(--m78-animate-base) 0.1s;
  -o-transition: opacity var(--m78-animate-base) 0.1s;
  transition: opacity var(--m78-animate-base) 0.1s;
  opacity: 0.7;
}

.effect-scale {
  cursor: pointer;
  -webkit-transition: -webkit-transform var(--m78-animate-base);
  transition: -webkit-transform var(--m78-animate-base);
  -o-transition: transform var(--m78-animate-base);
  transition: transform var(--m78-animate-base);
  transition: transform var(--m78-animate-base),
    -webkit-transform var(--m78-animate-base);
}

.effect-scale:hover {
  -webkit-transform: scale3d(1.1, 1.1, 1.1);
  transform: scale3d(1.1, 1.1, 1.1);
}

.effect-scale:active {
  -webkit-transition: -webkit-transform var(--m78-animate-base) 0.1s;
  transition: -webkit-transform var(--m78-animate-base) 0.1s;
  -o-transition: transform var(--m78-animate-base) 0.1s;
  transition: transform var(--m78-animate-base) 0.1s;
  transition: transform var(--m78-animate-base) 0.1s,
    -webkit-transform var(--m78-animate-base) 0.1s;
  -webkit-transform: scale3d(1.05, 1.05, 1.05);
  transform: scale3d(1.05, 1.05, 1.05);
}

.effect-font-color {
  cursor: pointer;
  color: var(--m78-color);
  -webkit-transition: -webkit-transform var(--m78-animate-base);
  transition: -webkit-transform var(--m78-animate-base);
  -o-transition: transform var(--m78-animate-base);
  transition: transform var(--m78-animate-base);
  transition: transform var(--m78-animate-base),
    -webkit-transform var(--m78-animate-base);
}

.effect-font-color:hover {
  color: var(--m78-color-4);
}

.effect-font-color:active {
  -webkit-transition: -webkit-transform var(--m78-animate-base) 0.1s;
  transition: -webkit-transform var(--m78-animate-base) 0.1s;
  -o-transition: transform var(--m78-animate-base) 0.1s;
  transition: transform var(--m78-animate-base) 0.1s;
  transition: transform var(--m78-animate-base) 0.1s,
    -webkit-transform var(--m78-animate-base) 0.1s;
  color: var(--m78-color-8);
}

.cus-p {
  cursor: pointer;
}

.cus-na {
  cursor: not-allowed;
}

.m78-stress {
  text-shadow: var(--m78-stress-shadow-b);
}

@supports (mix-blend-mode: difference) {
  .m78-stress {
    mix-blend-mode: difference;
    text-shadow: none;
  }
}

.m78-column {
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  flex-direction: column;
}

.m78-column,
.m78-row {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: normal;
}

.m78-row {
  -webkit-box-orient: horizontal;
  -ms-flex-direction: row;
  flex-direction: row;
}

.m78-main-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.m78-main-start {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.m78-main-end {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.m78-main-around {
  -ms-flex-pack: distribute;
  justify-content: space-around;
}

.m78-main-between {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.m78-main-evenly {
  -webkit-box-pack: space-evenly;
  -ms-flex-pack: space-evenly;
  justify-content: space-evenly;
}

.m78-cross-stretch {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.m78-cross-start {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.m78-cross-end {
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}

.m78-cross-center {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.m78-self-center {
  -ms-flex-item-align: center;
  align-self: center;
}

.m78-self-stretch {
  -ms-flex-item-align: stretch;
  align-self: stretch;
}

.m78-self-start {
  -ms-flex-item-align: start;
  align-self: flex-start;
}

.m78-self-end {
  -ms-flex-item-align: end;
  align-self: flex-end;
}

.m78-order-minus1 {
  -webkit-box-ordinal-group: 0;
  -ms-flex-order: -1;
  order: -1;
}

.m78-order-1 {
  -webkit-box-ordinal-group: 2;
  -ms-flex-order: 1;
  order: 1;
}

.m78-order-2 {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 2;
  order: 2;
}

.m78-order-3 {
  -webkit-box-ordinal-group: 4;
  -ms-flex-order: 3;
  order: 3;
}

.m78-order-4 {
  -webkit-box-ordinal-group: 5;
  -ms-flex-order: 4;
  order: 4;
}

.m78-order-5 {
  -webkit-box-ordinal-group: 6;
  -ms-flex-order: 5;
  order: 5;
}

.m78-flex-1 {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.m78-flex-2 {
  -webkit-box-flex: 2;
  -ms-flex: 2;
  flex: 2;
}

.m78-flex-3 {
  -webkit-box-flex: 3;
  -ms-flex: 3;
  flex: 3;
}

.m78-flex-4 {
  -webkit-box-flex: 4;
  -ms-flex: 4;
  flex: 4;
}

.m78-flex-5 {
  -webkit-box-flex: 5;
  -ms-flex: 5;
  flex: 5;
}

.m78-divider {
  background-color: var(--m78-color-divider);
  height: 0.5px;
  width: 100%;
  margin: 12px 0;
}

.m78-divider.__vertical {
  display: inline-block;
  vertical-align: middle;
  height: 1.2em;
  width: 0.5px;
  margin: 0 12px;
}

.m78-center {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.m78-aspect-ratio {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 100%;
}

.m78-aspect-ratio_scaffold {
  float: left;
  padding-top: 100%;
  visibility: hidden;
}

.m78-tile_leading {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  margin-right: 10px;
}

.m78-tile_main {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.m78-tile_trailing {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  margin-left: 10px;
}

.m78-dot.__primary {
  background-color: #194abe;
}

.m78-dot.__second {
  background-color: #bbd3f2;
}

.logo {
  height: 118px;
}

.search-inp {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: hsla(0, 0%, 100%, 0.8);
  height: 40px;
  border-radius: 6px;
  width: 342px;
}

.search-inp_prefix {
  padding: 0 8px;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}

.search-inp select {
  color: #194abe;
}

.search-inp input {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 4px 12px;
}

.search-inp button {
  -ms-flex-item-align: stretch;
  align-self: stretch;
  padding: 0 12px;
}

.search-inp button,
.search-inp input,
.search-inp select {
  background: transparent;
  border: none;
}

.nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 50px;
  background-color: #194abe;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  border-radius: 6px 6px 0 0;
}

.nav,
.nav a {
  color: #fff;
}

.nav_sub_h a {
  color: #0c0d0f;
}

.nav_item {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.nav_item:last-child {
  border-top-right-radius: 6px;
}

.nav_item.__active > a {
  display: inline-block;
  color: #194abe;
  padding: 4px 24px;
  border-radius: 20px;
  background-color: #fff;
  font-size: 18px;
}

.nav_item.__red {
  background-color: #e51725;
}

.nav_item > a {
  cursor: pointer;
  -webkit-transition: opacity var(--m78-animate-base);
  -o-transition: opacity var(--m78-animate-base);
  transition: opacity var(--m78-animate-base);
  font-size: 18px;
}

.nav_item > a:hover {
  opacity: 0.8;
}

.nav_item > a:active {
  -webkit-transition: opacity var(--m78-animate-base) 0.1s;
  -o-transition: opacity var(--m78-animate-base) 0.1s;
  transition: opacity var(--m78-animate-base) 0.1s;
  opacity: 0.7;
}

.nav_item:hover .nav_sub {
  display: block;
}

.nav_item_h:hover .nav_sub_h {
  display: block;
}

.nav_sub {
  display: none;
  position: absolute;
  top: 100%;
  background-color: #0634a1;
  z-index: 9999;
  white-space: nowrap;
  border-radius: 16px;
}

.nav_sub-item {
  display: block;
  padding: 10px 40px;
  font-weight: 500;
}

.nav_sub-item:hover {
  background-color: #194abe;
}

.notice-bar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 40px;
  background-color: hsla(0, 0%, 100%, 0.8);
  border-radius: 0 0 6px 6px;
}

.notice-bar_prefix {
  padding: 0 12px;
  color: #194abe;
}

.notice-bar_suffix {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 12px;
}

.notice-bar_content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 20px;
  overflow: hidden;
  white-space: nowrap;
}

.notice-bar_item {
  position: absolute;
  padding-right: 300px;
}

.notice-bar_btn {
  display: inline-block;
  border-radius: 50%;
  background-color: #fff;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.notice-bar_btn.__reverse {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.notice-bar_no {
  padding: 0 12px;
}

.banner-img {
  display: block;
}

.banner-img img {
  width: 100%;
}

.m-column {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.m-column.__auto {
  -webkit-box-flex: 0 !important;
  -ms-flex: 0 0 auto !important;
  flex: 0 0 auto !important;
}

.m-column_side {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
}

.m-column_side + .m-column_side {
  margin-left: 16px;
}

.slide-banner {
  width: 600px;
  height: 400px;
  white-space: nowrap;
  overflow: hidden;
}

.slide-banner_item {
  position: relative;
  display: inline-block;
  width: 600px;
  height: 400px;
}

.slide-banner_desc {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 42px;
  line-height: 42px;
  background-color: rgba(0, 0, 0, 0.45);
  color: hsla(0, 0%, 100%, 0.95);
  padding: 0 60px 0 12px;
}

.slide-banner img {
  width: 100%;
  height: 100%;
}

.tab1 {
  margin-top: 6px;
}

.tab1_tabs {
  height: 42px;
  background-color: #ebedf2;
  font-size: 22px;
}

.tab1_item,
.tab1_tabs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.tab1_item {
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 196px;
  border-radius: 6px 6px 0 0;
  cursor: pointer;
}

.tab1_item:first-child {
  color: #e51725;
}

.tab1_item:nth-child(2) {
  color: #194abe;
}

.tab1_item:nth-child(2).__active {
  background-color: #194abe;
}

.tab1_item:nth-child(2).__active:after {
  border-top-color: #194abe;
}

.tab1_item.__active {
  background-color: #e51725;
  margin-top: -6px;
  color: #fff;
  font-weight: 700;
}

.tab1_item.__active:after {
  position: absolute;
  bottom: -12px;
  content: "";
  border: 6px solid transparent;
  border-top-color: #e51725;
  -webkit-transform: scaleX(1.5);
  transform: scaleX(1.5);
}

.tab1_cont {
  display: none;
}

.tab1_cont.__active {
  display: block;
}

.more-bar {
  height: 32px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #eef3ff;
  cursor: pointer;
  -webkit-transition: opacity var(--m78-animate-base);
  -o-transition: opacity var(--m78-animate-base);
  transition: opacity var(--m78-animate-base);
}

.more-bar:hover {
  opacity: 0.8;
}

.more-bar:active {
  -webkit-transition: opacity var(--m78-animate-base) 0.1s;
  -o-transition: opacity var(--m78-animate-base) 0.1s;
  transition: opacity var(--m78-animate-base) 0.1s;
  opacity: 0.7;
}

.main-list {
  display: block;
  padding: 12px 0 12px 12px;
  color: rgba(0, 0, 0, 0.45) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 12px;
}

.main-list_title {
  font-size: 24px;
  font-weight: 700;
  color: #e51725;
}

.main-list:hover .main-list_title {
  text-decoration: underline;
}

.list1 {
  position: relative;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 2.4;
  font-size: 16px;
}

.list1_link {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: rgba(0, 0, 0, 0.75);
  margin-right: 16px;
}

.list1_link:hover {
  text-decoration: underline;
}

.list1_time {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.list1.__type2 {
  line-height: 3;
  padding: 0 32px 0 12px;
  overflow: visible;
}

.list1.__type2:nth-of-type(5n) {
  margin-bottom: 50px;
}

.list1.__type2:nth-of-type(5n):after {
  pointer-events: none;
  position: absolute;
  bottom: -70%;
  display: block;
  content: "";
  height: 0;
  width: 96%;
  border-top: 1px dashed rgba(0, 0, 0, 0.15);
}

.list1.__type2 .list1_link {
  text-decoration: none !important;
}

.list1.__type2:hover {
  background-color: #e9f0ff;
}

.list1.__type2:hover .m78-dot {
  background-color: #194abe;
}

.list1.__type2:hover .list1_link,
.list1.__type2:hover .list1_time {
  color: #194abe;
}

.list2 {
  display: block;
  padding: 18px 32px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
  cursor: pointer;
  -webkit-transition: background-color var(--m78-animate-base);
  -o-transition: background-color var(--m78-animate-base);
  transition: background-color var(--m78-animate-base);
}

.list2 .color-title {
  font-size: 24px;
  font-weight: 500;
}

.list2:hover {
  background-color: var(--m78-color-divider);
}

.list2:active {
  -webkit-transition: background-color var(--m78-animate-base) 0.1s;
  -o-transition: background-color var(--m78-animate-base) 0.1s;
  transition: background-color var(--m78-animate-base) 0.1s;
  background-color: var(--m78-color-border);
}

.title1 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
}

.title1.__type2 {
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(229, 23, 37, 0.5)),
    color-stop(20%, rgba(229, 23, 37, 0.2)),
    to(#f5f5f5)
  );
  background: -o-linear-gradient(
    left,
    rgba(229, 23, 37, 0.5) 0,
    rgba(229, 23, 37, 0.2) 20%,
    #f5f5f5 100%
  );
  background: linear-gradient(
    90deg,
    rgba(229, 23, 37, 0.5) 0,
    rgba(229, 23, 37, 0.2) 20%,
    #f5f5f5
  );
  padding: 6px !important;
  border: none;
}

.title1.__type3 {
  border: none;
  padding-bottom: 0;
}

.title1.__type3 .title1_text {
  color: #194abe;
}

.title1.__type4 {
  border: none;
  padding: 0;
}

.title1_text {
  font-size: 24px;
  font-weight: 700;
}

.title1_more {
  color: rgba(0, 0, 0, 0.45);
}

.title2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 54px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 32px;
}

.title2 .title2_main {
  font-size: 22px;
  font-weight: 700;
  height: 100%;
  line-height: 54px;
  padding: 0 16px;
  display: inline-block;
  border-bottom: 4px solid #194abe;
}

.entry,
.entry-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.entry_item {
  display: inline-block;
  position: relative;
  width: 230px;
  height: 200px;
  color: #fff !important;
  text-align: center;
  padding-top: 40px;
  cursor: pointer;
  -webkit-transition: opacity var(--m78-animate-base);
  -o-transition: opacity var(--m78-animate-base);
  transition: opacity var(--m78-animate-base);
}

.entry_item + .entry_item {
  margin-left: 12px;
}

.entry_item.__bg1 {
  background: url(/home/10.png) 50%/100%;
}

.entry_item.__bg2 {
  background: url(/home/11.png) 50%/100%;
}

.entry_item:hover {
  opacity: 0.8;
}

.entry_item:active {
  -webkit-transition: opacity var(--m78-animate-base) 0.1s;
  -o-transition: opacity var(--m78-animate-base) 0.1s;
  transition: opacity var(--m78-animate-base) 0.1s;
  opacity: 0.7;
}

.entry_item-img {
  width: 54px;
}

.entry_item-title {
  font-size: 22px;
  font-weight: 500;
  margin-top: 12px;
}

.entry_item-desc {
  color: hsla(0, 0%, 100%, 0.45);
}

.entry + .entry2 {
  margin-left: 12px;
}

.entry2_item-img {
  width: 42px;
  height: 42px;
  margin-right: 8px;
}

.entry2_item {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  vertical-align: top;
  color: rgba(0, 0, 0, 0.75);
  padding-left: 40px;
  width: 230px;
  height: 94px;
  background-color: #f1f5f8;
  border-radius: 6px;
  margin-right: 12px;
}

.entry2_item:hover {
  background-color: #1852c7;
  color: #fff;
}

.entry2_item:hover .entry2_item-title {
  color: hsla(0, 0%, 100%, 0.8) !important;
}

.entry2_item:hover .entry2_item-desc {
  color: hsla(0, 0%, 100%, 0.2) !important;
}

.entry2_item:hover .entry2_item-img {
  -webkit-filter: brightness(10);
  filter: brightness(10);
}

.entry2_item:nth-child(n + 4) {
  margin-top: 12px;
}

.entry2_item:nth-child(3n) {
  margin-right: 0;
}

.entry2_item-title {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.75);
  font-weight: 500;
  line-height: 1.3;
}

.entry2_item-desc {
  color: rgba(0, 0, 0, 0.15);
}

.entry3 {
  padding-top: 12px;
}

.entry3_item {
  position: relative;
  display: block;
  cursor: pointer;
  -webkit-transition: opacity var(--m78-animate-base);
  -o-transition: opacity var(--m78-animate-base);
  transition: opacity var(--m78-animate-base);
}

.entry3_item > img {
  width: 100%;
  height: 100%;
}

.entry3_item + .entry3_item {
  margin-top: 24px;
}

.entry3_item:hover {
  opacity: 0.8;
}

.entry3_item:active {
  -webkit-transition: opacity var(--m78-animate-base) 0.1s;
  -o-transition: opacity var(--m78-animate-base) 0.1s;
  transition: opacity var(--m78-animate-base) 0.1s;
  opacity: 0.7;
}

.entry3_text {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 26px;
  white-space: nowrap;
  color: #fff;
  font-weight: 700;
}

.gray-box {
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 12px;
}

.inp {
  border: 1px solid #bbc2cb;
  padding: 12px 16px;
  resize: none;
  font-size: 16px;
}

textarea.inp {
  display: block;
  width: 100%;
  height: 148px;
}

.feedback_action {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.feedback_action,
.feedback_action-left {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.feedback_btn {
  border: none;
  height: 50px;
  width: 160px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#6a92ff),
    to(#1852c7)
  );
  background: -o-linear-gradient(top, #6a92ff 0, #1852c7 100%);
  background: linear-gradient(180deg, #6a92ff, #1852c7);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}

.feedback_btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.units {
  position: relative;
  margin-top: 24px;
  margin-bottom: 12px;
}

.units_inner-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  overflow: hidden;
}

.units_next,
.units_prev {
  position: absolute;
  width: 28px;
  height: 58px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  z-index: 100;
  cursor: pointer;
}

.units_prev {
  left: 0;
}

.units_next {
  right: 0;
}

.units_wrap {
  width: 1200px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  display: inline-block;
}

.units_item {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 390px;
  height: 94px;
  background: url(/home/29.png) 50%/100%;
  font-size: 22px;
  font-weight: 700;
  color: #fff !important;
  margin-right: 10px;
  margin-top: 16px;
  cursor: pointer;
  -webkit-transition: opacity var(--m78-animate-base);
  -o-transition: opacity var(--m78-animate-base);
  transition: opacity var(--m78-animate-base);
}

.units_item:hover {
  opacity: 0.8;
}

.units_item:active {
  -webkit-transition: opacity var(--m78-animate-base) 0.1s;
  -o-transition: opacity var(--m78-animate-base) 0.1s;
  transition: opacity var(--m78-animate-base) 0.1s;
  opacity: 0.7;
}

.units_item:nth-child(3n) {
  margin-right: 0;
}

.units_item:nth-child(-n + 3) {
  margin-top: 0;
}

.links {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.links_title {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 120px;
  height: 120px;
  font-size: 24px;
  font-weight: 700;
  color: #194abe;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(24, 82, 199, 0.4)),
    to(rgba(24, 82, 199, 0))
  );
  background: -o-linear-gradient(
    top,
    rgba(24, 82, 199, 0.4) 0,
    rgba(24, 82, 199, 0) 100%
  );
  background: linear-gradient(
    180deg,
    rgba(24, 82, 199, 0.4),
    rgba(24, 82, 199, 0)
  );
  padding: 20px 36px;
}

.links_cont {
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 18px;
  padding: 16px 0;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.links_cont a {
  display: inline-block;
  width: 25%;
  text-align: center;
  padding: 4px;
  color: rgba(0, 0, 0, 0.75);
}

.links_cont a:hover {
  color: #e51725;
  text-decoration: underline;
}

.main-box {
  border-radius: 6px;
  background-color: #fff;
  min-height: 500px;
  margin-top: 24px !important;
  margin-bottom: 32px !important;
  overflow: hidden;
}

.main-box_inner {
  padding: 16px;
}

.top-bar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 54px;
  padding: 0 12px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
}

.crumbs_label {
  margin-right: 8px;
  color: rgba(0, 0, 0, 0.45);
}

.crumbs a {
  display: inline-block;
  color: rgba(0, 0, 0, 0.45);
}

.crumbs a:after {
  display: inline-block;
  content: "";
  background: url(/home/22.png) 50%/100%;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
  opacity: 0.4;
}

.crumbs a:last-child {
  color: rgba(0, 0, 0, 0.9);
  cursor: auto !important;
}

.crumbs a:last-child:after {
  display: none;
}

.ls-side {
  width: 268px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  background: url(/home/40.png) bottom/100% no-repeat #194abe;
  border-radius: 6px;
  overflow: hidden;
  min-height: 440px;
}

.ls-side_title {
  padding: 12px;
  text-align: center;
  background-color: #2a63d8;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
}

.ls-side_item {
  display: inline-block;
  color: #fff !important;
  width: 250px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin-left: 20px;
  text-indent: -20px;
  font-size: 18px;
  padding: 0 20px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  -webkit-transition: opacity var(--m78-animate-base);
  -o-transition: opacity var(--m78-animate-base);
  transition: opacity var(--m78-animate-base);
}

.ls-side_item.__active {
  background-color: #fff;
  color: #194abe !important;
  font-weight: 700;
  border-left: 4px solid #e51725;
  margin-left: 18px;
}

.ls-side_item:hover {
  opacity: 0.8;
}

.ls-side_item:active {
  -webkit-transition: opacity var(--m78-animate-base) 0.1s;
  -o-transition: opacity var(--m78-animate-base) 0.1s;
  transition: opacity var(--m78-animate-base) 0.1s;
  opacity: 0.7;
}

.ls-side2 {
  width: 286px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  background-color: #f2f6fa;
}

.ls-side2_item {
  color: rgba(0, 0, 0, 0.75) !important;
  display: block;
  line-height: 2.6;
  font-size: 16px;
}

.ls-side2_item:hover {
  color: #194abe !important;
}

.ls-side2_cont {
  padding: 0 16px 32px;
}

.page-elem-field {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 36px;
  line-height: 36px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.page-elem-field .item {
  width: auto !important;
  height: auto !important;
  padding: 4px 10px !important;
  text-align: center !important;
  margin: 0 2px !important;
  border: none !important;
  -webkit-transition: background-color var(--m78-animate-base);
  -o-transition: background-color var(--m78-animate-base);
  transition: background-color var(--m78-animate-base);
}

.page-elem-field .item .active {
  background-color: #194abe !important;
  color: #fff !important;
}

.page-elem-field .item .foot,
.page-elem-field .item .head {
  border: 1px solid #194abe !important;
  color: #194abe !important;
  margin: 0 20px !important;
}

.page-elem-field .item .foot,
.page-elem-field .item .head {
  border: 1px solid #194abe !important;
}

.page-elem-field .item.__disabled {
  background-color: rgba(0, 0, 0, 0.15) !important;
  color: rgba(0, 0, 0, 0.25) !important;
  border: none !important;
  cursor: not-allowed !important;
}

.page-elem-field .item:hover {
  background-color: var(--m78-color-divider);
}

.page-elem-field .item:active {
  -webkit-transition: background-color var(--m78-animate-base) 0.1s;
  -o-transition: background-color var(--m78-animate-base) 0.1s;
  transition: background-color var(--m78-animate-base) 0.1s;
  background-color: var(--m78-color-border);
}

.pager2 {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  padding-top: 30px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.pager2,
.pager2_item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.pager2_item {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.45);
}

.pager2_text {
  display: inline-block;
  max-width: 200px;
}

.article-meta {
  padding: 12px 12px 24px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
  margin-bottom: 24px;
}

.article-meta_title {
  font-size: 28px;
  font-weight: 700;
  text-align: center;
}

.article-meta_desc {
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  margin-top: 16px;
}

.article-box {
  padding: 0 50px 80px;
}

.article-box iframe,
.article-box img,
.article-box table,
.article-box video {
  max-width: 100%;
}

.table {
  width: 100%;
}

.table thead tr {
  height: 40px;
  background-color: #fef8ef;
}

.table tbody tr {
  height: 60px;
  cursor: pointer;
  -webkit-transition: background-color var(--m78-animate-base);
  -o-transition: background-color var(--m78-animate-base);
  transition: background-color var(--m78-animate-base);
}

.table tbody tr:nth-child(2n) {
  background-color: #f5f9fb;
}

.table tbody tr:hover {
  background-color: var(--m78-color-divider);
}

.table tbody tr:active {
  -webkit-transition: background-color var(--m78-animate-base) 0.1s;
  -o-transition: background-color var(--m78-animate-base) 0.1s;
  transition: background-color var(--m78-animate-base) 0.1s;
  background-color: var(--m78-color-border);
}

.table td {
  padding: 0 16px;
}

.table td:first-child {
  text-align: center;
}

.table td:nth-child(2) {
  color: #194abe;
}

.empty {
  text-align: center;
  padding: 32px;
}

.empty img {
  width: 144px;
  height: 150px;
}

.not-found {
  text-align: center;
  padding: 160px 0;
}

.not-found_img {
  width: 490px;
  height: 340px;
}

.not-found_title {
  font-weight: 700;
  font-size: 24px;
}

.not-found_desc {
  color: rgba(0, 0, 0, 0.45);
}

.slick-dots {
  bottom: 6px !important;
  z-index: 100 !important;
  width: auto !important;
  right: 16px !important;
}

.slick-dots li {
  margin: 0 !important;
}

.slick-dots li button:before {
  color: #fff !important;
  opacity: 0.6 !important;
}

.slick-dots .slick-active button:before {
  color: #e51725 !important;
  opacity: 1 !important;
}

.back-top {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: fixed;
  right: 32px;
  bottom: 50px;
  width: 68px;
  height: 68px;
  -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  z-index: 1000;
  background-color: #fff;
  cursor: pointer;
  -webkit-transition: -webkit-transform var(--m78-animate-base);
  transition: -webkit-transform var(--m78-animate-base);
  -o-transition: transform var(--m78-animate-base);
  transition: transform var(--m78-animate-base);
  transition: transform var(--m78-animate-base),
    -webkit-transform var(--m78-animate-base);
}

.back-top:hover {
  -webkit-transform: scale3d(1.1, 1.1, 1.1);
  transform: scale3d(1.1, 1.1, 1.1);
}

.back-top:active {
  -webkit-transition: -webkit-transform var(--m78-animate-base) 0.1s;
  transition: -webkit-transform var(--m78-animate-base) 0.1s;
  -o-transition: transform var(--m78-animate-base) 0.1s;
  transition: transform var(--m78-animate-base) 0.1s;
  transition: transform var(--m78-animate-base) 0.1s,
    -webkit-transform var(--m78-animate-base) 0.1s;
  -webkit-transform: scale3d(1.05, 1.05, 1.05);
  transform: scale3d(1.05, 1.05, 1.05);
}

.back-top img {
  width: 32px;
}

.w-full {
  width: 100%;
  height: 100%;
}

.body-bg {
  background: url(/home/46.png);
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
}

.body-bg .h-img-block {
  margin-top: 90px;
  text-align: center;
}

.body-bg .h-img-block .h-img {
  margin: 0 auto;
}

.body-bg .login {
  margin-top: 43px;
}

.body-bg .login .login-form {
  width: 412px;
  background: #fff;
  margin: 0 auto;
  padding: 20px 20px 40px 22px;
}

.body-bg .login .login-form_title {
  color: #272f3c;
  font-size: 24px;
  font-weight: 700;
  line-height: 26px;
  text-align: left;
  border-bottom: 1px solid #dbdbdb;
  padding-bottom: 18px;
}

.body-bg .login .login-form_item {
  width: 302px;
  height: 42px;
  border: 1px solid #bdc3cb;
  padding: 0 11px;
  font-size: 14px;
  margin-left: 32px;
  margin-top: 19px;
}

.body-bg .login .login-form .margin-top-29 {
  margin-top: 29px;
}

.body-bg .login .login-form .pos-input {
  position: relative;
  height: 42px;
  margin-top: 18px;
}

.body-bg .login .login-form .pos-input .margin-top-0 {
  margin-top: 0;
}

.body-bg .login .login-form .pos-input .code-block {
  position: absolute;
  top: 0;
  right: 36px;
  width: 102px;
  height: 42px;
  text-align: center;
  line-height: 42px;
  color: #194abe;
  border: 1px solid #194abe;
  font-size: 14px;
  cursor: pointer;
}

.body-bg .login .login-form .login-form_assist {
  width: 302px;
  margin-top: 15px;
  margin-left: 32px;
  margin-bottom: 19px;
  vertical-align: middle;
}

.body-bg .login .login-form .login-form_assist_isAgree {
  display: inline-block;
  margin-right: 8px;
}

.body-bg .login .login-form .login-form_assist_isAgree:checked:after {
  background: #dc143c;
}

.body-bg .login .login-form .login-form_assist a {
  float: right;
  text-decoration: underline;
  color: #71767c;
  font-size: 14px;
}

.body-bg .login .login-form .login-but {
  width: 302px;
  height: 48px;
  background: #194abe;
  opacity: 1;
  border-radius: 6px;
  margin-left: 32px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  border: none;
}

.body-bg .login .login-form .login-register {
  width: 302px;
  height: 48px;
  background: #fff;
  opacity: 1;
  margin-left: 32px;
  color: #194abe;
  font-size: 16px;
  font-weight: 700;
  margin-top: 24px;
  text-align: center;
  line-height: 48px;
  border: 1px solid #194abe;
  cursor: pointer;
  border-radius: 6px;
}

.body-bg .login .login-form .font-wraing {
  color: #ff7476;
  font-size: 14px;
  margin-left: 32px;
  margin-top: 6px;
}

.body-bg .login .login-form .wraing-icon {
  display: inline-block;
  margin-right: 10px;
}

body,
html {
  height: 100%;
}

body {
  background-color: #f5f9fb;
}

::-moz-selection {
  background-color: rgba(25, 74, 190, 0.5);
}

::selection {
  background-color: rgba(25, 74, 190, 0.5);
}

.bg-gray {
  background-color: #f5f9fb;
  padding: 24px 0;
}

.bg-white {
  background-color: #fff;
  padding: 24px 0;
}

.w-1200 {
  width: 1200px;
  margin: 0 auto;
}

.host {
  position: relative;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 1200px;
}

.host:after {
  height: 380px;
  top: 0;
  left: 0;
  z-index: -2;
  background: url("../assets/8.png") top/cover no-repeat;
}

.host:after,
.host:before {
  content: "";
  position: absolute;
  width: 100%;
}

.host:before {
  height: 160px;
  top: 220px;
  z-index: -1;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(hsla(0, 0%, 100%, 0)),
    to(#fff)
  );
  background: -o-linear-gradient(top, hsla(0, 0%, 100%, 0), #fff);
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.header_top {
  padding: 64px 0 44px;
  width: 1200px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.header_main {
  width: 1200px;
  margin: 0 auto;
  border-radius: 6px;
}

.content {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.footer {
  position: relative;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  height: 384px;
  background: url(/home/32.png) 50% / cover no-repeat;
  color: hsla(0, 0%, 100%, 0.8);
}

.footer_title {
  font-size: 24px;
  font-weight: 500;
  border-left: 3px solid hsla(0, 0%, 100%, 0.45);
  text-align: left;
  line-height: 1;
  margin-bottom: 32px;
  padding-left: 12px;
  margin-left: -16px;
}

.footer_wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 1200px;
  margin: 40px auto 0;
}

.footer_contact {
  width: 150px;
}

.footer_column {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0 60px;
}

.footer_column-item {
  max-width: 150px;
  line-height: 2;
}

.footer_column-item + .footer_column-item {
  margin-left: 32px;
}

.footer_column-item a {
  display: block;
  color: hsla(0, 0%, 100%, 0.8);
}

.footer_column-title {
  color: hsla(0, 0%, 100%, 0.45) !important;
  margin-bottom: 20px;
}

.footer_ewm {
  text-align: center;
}

.footer_ewm-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.footer_ewm-img {
  width: 148px;
  height: 148px;
  margin-bottom: 16px;
}

.footer_ewm-item + .footer_ewm-item {
  margin-left: 40px;
}

.footer_gray {
  color: hsla(0, 0%, 100%, 0.45);
  margin-top: 4px;
}

.footer_link {
  color: hsla(0, 0%, 100%, 0.8);
  text-decoration: underline;
}

.footer_link + .footer_link {
  margin-left: 8px;
}

.footer_link:hover {
  color: #e51725;
}

.footer_metas {
  position: absolute;
  bottom: 12px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  white-space: nowrap;
}

.page-elem-field {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.page-elem-field .item {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  border: 1px solid #e2e2e2;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.page-elem-field .item.active {
  background-color: #194abe;
  color: #fff;
}

.page-elem-field .item:hover {
  background-color: #bfbfbf;
}

.page-elem-field .item.item-disable {
  color: #d2d2d2 !important;
  cursor: not-allowed !important;
}

.page-elem-field .item.active:hover {
  background-color: #1e9fff;
  color: #fff;
}

// 自定义
.nav_item_a {
  width: 110px;
  height: 34px;
  background: #ffffff;
  opacity: 1;
  border-radius: 17px;
  color: #e51725 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.nav_sub_h {
  display: none;
  top: 60px !important;
  position: absolute;
  top: 100%;
  background-color: #f5f9fb;
  z-index: 9999;
  white-space: nowrap;
  border-radius: 36px;
  // box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}

.nav_sub_h::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-bottom: 14px solid #ffffff;
  top: -10px;
  left: 45%;
}

.nav_sub-item_h {
  display: block;
  padding: 10px 40px;
  font-weight: 500;
  color: #7c828a;
}

.nav_sub-item_h_s {
  display: block;
  padding: 10px 40px;
  font-weight: 500;
  background-color: #ffffff !important;
}

.nav_sub-item_h_s_t_r {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.nav_sub-item_h_s_b_r {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.nav_sub-item_h_s img {
  width: 22px;
  height: 16px;
}

.nav_sub-item_h_s .guanbi {
  width: 11.2px;
  height: 12.7px;
}

.nav_sub-item_h_s_red {
  color: #ff636d !important;
}

.nav_sub-item_h:hover {
  background-color: #194abe;
  color: #ffffff;
}

.nav_sub-item_h_s_m {
  display: block;
  width: 176px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #194abe;
  opacity: 1;
  border-radius: 6px;
  line-height: 38px;
  text-align: center;
}

.nav_sub-item_h_s_t {
  text-align: center;
  padding: 10px 0px;
  font-size: 14px;

  span {
    color: #7c828a;
  }

  a {
    color: #194abe;
  }
}
.w1200 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  .logo_title {
    display: flex;
    align-items: flex-end;
    p {
      margin-bottom: 20px;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 21px;
      color: #ffffff;
      text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.66);
    }
  }
  .header_logo {
    width: 365px;
    height: 113px;
  }
  .back_choice {
    display: flex;
	align-items: center;
	.left{
    cursor: pointer;
		color: #194ABE;
	}
	.right{
    cursor: pointer;
		color: #E51725;
	}
    .left,
    .right {
      display: flex;
      align-items: center;
      padding: 0 10px;
      height: 34px;
      background: rgba(255, 255, 255, 0.73);
      border-radius: 6px;
      justify-content: center;
      margin: 0 10px;
      img {
        width: 24px;
        height: 24px;
      }
      p {
        margin: 0;
      }
    }
  }
}
</style>
